import React, { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import * as PropTypes from 'prop-types';

const Component = forwardRef(({ children, bold, onClick, disabled, 'data-e2e': dataE2e, role }, ref) => (
  <li
    className={`ct-simple-dropdown-elem${bold ? ' ct-simple-dropdown-elem--bold' : ''}${
      disabled ? ' ct-simple-dropdown-elem--disabled' : ''
    }`}
    role="none"
  >
    <button
      ref={ref}
      className="border-0 w-100 h-100 text-left bg-transparent"
      onClick={onClick}
      data-e2e={dataE2e}
      disabled={disabled}
      tabIndex={0}
      role={role}
    >
      {children}
    </button>
  </li>
));

export const SimpleDropDownElement = forwardRef((props, ref) =>
  props.linkTo ? (
    <li
    className={`ct-simple-dropdown-elem${props.bold ? ' ct-simple-dropdown-elem--bold' : ''}${
      props.disabled ? ' ct-simple-dropdown-elem--disabled' : ''
    }`}
    role="none"
  >
    <Link 
      to={props.linkTo}
      onClick={props.onClick}
      className="border-0 w-100 h-100 text-left bg-transparent d-block text-decoration-none"
      data-e2e={props['data-e2e']}
      ref={ref}
      role={props.role}
      tabIndex={0}
    >
      {props.children}
    </Link>
  </li>
  ) : (
    <Component {...props} ref={ref} />
  )
);

SimpleDropDownElement.propTypes = {
  bold: PropTypes.bool,
  onClick: PropTypes.func,
  linkTo: PropTypes.string,
  children: PropTypes.any,
  role: PropTypes.string,
};
